module.exports = __webpack_public_path__ + "static/media/axa-logo.d0603435.jpg";